import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild} from '@angular/router';
import {AuthenticationService} from '../services/authentication/authentication.service';
import {map, catchError} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class Gatekeeper implements CanActivate, CanActivateChild {

    constructor(private authenticationService: AuthenticationService,
                private router: Router) {
    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
        return this.authenticationService.checkLogin().pipe(
            map(response => {
                console.log(response);
                if (response.ok) {
                        /*
                         Here, check if any user roles needed to activate the route
                         */
                        const roles = route.data['roles'];
                        if (roles instanceof Array) {
                            return this.authenticationService.userHasRole(roles);
                        }
                        return true;
                    } else {
                        this.router.navigate(['/login']);
                        return false;
                    }
                }
            ),
            catchError((error) => {
                    this.router.navigate(['/login']);
                    return Observable.of(false);
                }
            )
        );
    }


    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
        return this.canActivate(childRoute, state);
    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/guards/gatekeeper.guard.ts